import styled from 'styled-components';

export const CardContainer = styled.div`
	width: 100%;
	position: relative;
	${props => props.theme.breakpoints.up('xs')} {
		text-align: center;
	}
	${props => props.theme.breakpoints.up('md')} {
		text-align: left;
	}
	.container-image {
		background-image: url(${props => props.image});
		height: 125px;
		width: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}
	.content-card {
		border: solid 1px #70707066;
		padding: 5%;
		${props => props.theme.breakpoints.up('xs')} {
			min-height: initial;
		}
		${props => props.theme.breakpoints.up('sm')} {
			min-height: 65px;
			height: 100%;
		}
		${props => props.theme.breakpoints.up('md')} {
			min-height: 60px;
			height: 100%;
		}
	}
	.description-card {
		font-weight: 400;
		${props => props.theme.breakpoints.up('xs')} {
			font-size: 16px;
			line-height: 20px;
		}
		${props => props.theme.breakpoints.up('md')} {
			font-size: 13px;
			line-height: 16px;
		}
	}
	.content-invisible {
		${props => props.theme.breakpoints.up('sm')} {
			display: none;
		}
	}

	.image-visible {
		${props => props.theme.breakpoints.up('sm')} {
			cursor: pointer;
			transition: 0.9s ease;
			height: 215px;
			background-size: contain;
			background-color: #000;
			height: 227px;
		}
		${props => props.theme.breakpoints.up('md')} {
			height: 215px;
		}
	}

	.MuiChip-root {
		position: absolute;
		top: 15px;
		background-color: #48e06c;
		color: #133407;
		font-size: 14px;
		font-weight: 900;

		${props => props.theme.breakpoints.up('xs')} {
			left: 0;
			right: 0;
			margin-left: auto;
			margin-right: auto;
			width: fit-content;
		}
		${props => props.theme.breakpoints.up('md')} {
			left: 15px;
			margin: 0px;
		}
	}
`;
export default CardContainer;
